import { useLingui } from '@lingui/react/macro';
import LoseBase from '../components/base/lose-base';
import { UDFormLabeledCheckbox, UDFormLabeledInput } from 'ud-form/components';

const FootballLose = () => {
  const { t } = useLingui();

  return (
    <LoseBase sportType="football">
      <div className="mt-4">
        <UDFormLabeledInput
          name="settings.lossPenaltySeries"
          placeholder={t`0 очков`}
          label={t`В серии послематчевых пенальти`}
          tooltip={t`Очки за проигрыш по пенальти (например, 1 очко за 'боевую ничью').`}
          tooltipProps={{ position: 'input-right' }}
        />

        <UDFormLabeledCheckbox
          name="settings.technicalDefeatGoalsCount"
          label={t`Учёт голов при техническом поражении`}
          containerClassName="flex items-center"
          tooltip={t`Засчитывать ли голы в статистику, если матч завершён техническим поражением (например, из-за неявки).`}
          tooltipProps={{ position: 'input-right' }}
        />
      </div>
    </LoseBase>
  );
};

export default FootballLose;
